import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51181f49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RPPOrdersListItem" }
const _hoisted_2 = { class: "flex items-center justify-between mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "ID заказа: " + _toDisplayString(_ctx.item.id), 1),
      _createElementVNode("span", null, "Номер заказа: " + _toDisplayString(_ctx.item.order_number || 'Нет данных'), 1),
      _createVNode(_component_checkbox, {
        class: "mt-2",
        value: _ctx.state.is_order_selected,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.is_order_selected) = $event)),
        "return-integer": "",
        onChange: _ctx.emitSelectOrder
      }, null, 8, ["value", "onChange"])
    ])
  ]))
}